<template>
  <div class="order-detail main-bg"  v-if="orderInfo">
    <div class="main-wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="crumb-wrap">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: role==='shop'?'/business/order': '/center/order'}">我的订单</el-breadcrumb-item>
        <el-breadcrumb-item>订单号：{{orderInfo.orderNum}}</el-breadcrumb-item>
      </el-breadcrumb>
      <!--<nav-crumb class="crumb-pt"></nav-crumb>-->
      <ul class="order-status">
        <li>
          <p v-if="goodsInfo.goodsType!==1&&orderInfo.status==0&&this.timeDiff>0" style="color: #15B249;font-size: 27px;padding-bottom: 30px;font-weight: 600;">{{timeDown}}</p>
          <p v-if="orderInfo.isOnline==1" class="status-flag">
            线下支付
            <br>
            {{orderInfo.isOnline==1?'待审核':'已拒绝'}}
          </p>
          <p v-if="orderInfo.isOnline!=1" class="status-flag" v-text="orderPayText(orderInfo.createTime,orderInfo.status,goodsInfo.goodsType,orderInfo.isReturn)"></p>
          <!--<button v-if="role==='user'&&goodsInfo.goodsType!==4" type="button" class="btn-base btn-buyOnce" @click="$router.push({'path':`/goods/detail/${goodsInfo.id}`})">再次购买</button>-->
        </li>
        <li>
          <div class="steps-main">
            <div class="line"></div>
            <p class="step-name step1-name">提交订单</p>
            <p class="step-time step1-time">{{orderInfo.createTime}}</p>
            <div class="step step1 active">1</div>
            <div class="line-active line0-active" v-if="orderInfo.payTime"></div>
            <p class="step-name step2-name">支付订单</p>
            <p class="step-time step2-time">{{orderInfo.payTime}}</p>
            <div class="step step2" :class="{'active':orderInfo.payTime}">2</div>
            <div class="line-active line1-active" v-if="orderInfo.sendTime"></div>
            <p class="step-name step3-name">卖家发货</p>
            <p class="step-time step3-time">{{orderInfo.sendTime}}</p>
            <div class="step step3" :class="{'active':orderInfo.sendTime}">3</div>
            <div class="line-active line2-active" v-if="orderInfo.completeTime"></div>
            <p class="step-name step4-name">完成收货</p>
            <p class="step-time step4-time">{{orderInfo.completeTime}}</p>
            <div class="step step4" :class="{'active':orderInfo.completeTime}">4</div>
          </div>
        </li>
      </ul>
      <div class="order-info">
        <p class="name">订单信息</p>
        <ul class="order-item">
          <li>订单编号：<span>{{orderInfo.orderNum}}</span></li>
          <li>收货人：<span>{{addressInfo.name}}</span></li>
          <li v-if="orderInfo.payTime">
            下单时间：
            <span>{{orderInfo.payTime}}</span></li>
          <li>
            联系电话：
            <span>20193819319910</span></li>
          <li v-if="shopInfo">
            卖家：
            <span>{{shopInfo.shopName}}</span></li>
          <li>
            收货地址：
            <span>{{addressInfo.provinceName}}{{addressInfo.cityName}}{{addressInfo.areaName}}{{addressInfo.address}}</span></li>
        </ul>
        <div v-if="orderInfo.isReturn==1">
          <p class="name">退货原因</p>
          <div v-text="orderInfo.returnDesc"></div>
        </div>
        <p class="name">商品信息</p>
        <ul class="tab-head">
          <li>商品名称</li>
          <li>数量</li>
          <li>价格</li>
          <li>操作</li>
        </ul>
        <ul class="tab-body">
          <li>
            <el-image class="order-img" :src="$common.imgPath(goodsInfo.goodsLog)" :alt="goodsInfo.goodsName" lazy></el-image>
            <span class="order-title">{{goodsInfo.goodsName}}</span>
          </li>
          <li class="txt-16">{{orderInfo.goodsNum}}</li>
          <li>
            <p class="total-money font-500 txt-16 c-333">¥{{goodsInfo.price}}</p>
          </li>
          <li>
            <div v-if="role==='user'">
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==0&&orderInfo.isOnline!=1" @click="$router.push({'path':'/goods/order/pay/'+orderInfo.id})">去支付</button>
              <!--<button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==0&&goodsInfo.goodsType==1" @click="cancelOrder(orderInfo.id,shopInfo.shopId)">取消订单</button>-->
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==1" @click="allPushContentOpt(orderInfo.id)">催一催</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==2" @click="orderCheckOver(orderInfo.id)">确认收货</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==3" @click="$router.push({'path':'/goods/order/pinJia/'+orderInfo.id})">去评价</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="(orderInfo.status==2||orderInfo.status==3)&&orderInfo.isReturn===0" @click="$router.push({'path':'/goods/order/applyAfterSale/'+orderInfo.id})">申请售后</button>
            </div>
            <!--<button type="button" class="btn-base btn-mini btn-item" v-if="role==='user'&&orderInfo.status==1" @click="allPushContentOpt(orderInfo.id)">催一催</button>-->
            <!--<button type="button" class="btn-base btn-mini btn-item" v-if="role==='user'&&orderInfo.status==0&& orderPayText(orderInfo.createTime,orderInfo.status,goodsInfo.goodsType,orderInfo.isReturn)==='待付款'" @click="$router.push({'path':'/goods/order/pay/'+orderInfo.id})">去支付</button>-->
            <!--<button type="button" class="btn-base btn-mini btn-item" v-if="role==='user'&&orderInfo.status==2" @click="orderCheckOver(orderInfo.id)">确认收货</button>-->
            <!--<button type="button" class="btn-base btn-mini btn-item" v-if="role==='user'&&orderInfo.status==3" @click="$router.push({'path':'/goods/order/pinJia/'+orderInfo.id})">去评价</button>-->
            <!--<button type="button" class="btn-base btn-mini btn-item" v-if="role==='user'&&(orderInfo.status==2 ||orderInfo.status==3)&&orderInfo.isReturn===0" @click="$router.push({'path':'/goods/order/applyAfterSale/'+orderInfo.id})">申请售后</button>-->

            <div v-if="role==='shop'">
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.isOnline==1" @click="applyStatus(3,orderInfo)">拒绝申请</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.isOnline==1" @click="applyStatus(2,orderInfo)">同意申请</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==0&&goodsInfo.goodsType==1&&orderInfo.isOnline!=1" @click="delOrder(orderInfo.id,shopInfo.shopId)">删除</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==6&&orderInfo.isOnline!=1" @click="delOrder(orderInfo.id,shopInfo.shopId)">删除</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==1" @click="sendOrder(orderInfo.id,goodsInfo.distributionFee)">确认发货</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==5&&orderInfo.isReturn==0" @click="setReturnOrderNo(orderInfo.id)">取消退款</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==5&&orderInfo.isReturn==0" @click="setReturnOrder(orderInfo.id)">确认退款</button>
              <button type="button" class="btn-base btn-mini btn-item" v-if="orderInfo.status==6&&orderInfo.isBlack!==1&&goodsInfo.goodsType!==1" @click="pullBlackUser(orderInfo.id)">拉黑</button>
            </div>
            <!--
                                    <button type="button" class="btn-base btn-mini btn-item" v-if="role==='shop'&& orderPayText(item.createTime,item.status,item.goods.goodsType,item.isReturn)==='已失效'" @click="cancelPullBlackUser(item.id)">取消拉黑</button>
            -->

          </li>
        </ul>
        <div class="count-list">
          <p>
            <span>商品总计：</span>
            <span>¥{{orderInfo.orderPrice}}</span>
          </p>
          <p>
            <span>运费金额：</span>
            <span>{{orderInfo.distributionFee==-1?'邮费到付':orderInfo.distributionFee==0?'包邮':'¥'+orderInfo.distributionFee}}</span>
          </p>
          <p v-if="orderInfo.status==0">
            <span>需付款：</span>
            <span>¥ <span class="total-money" v-text="orderInfo.orderPrice"></span></span>
          </p>
          <p v-if="orderInfo.status!==0">
            <span>实际付款：</span>
            <span>¥ <span class="total-money">{{orderInfo.realPrice}}</span></span>
          </p>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import navCrumb from '../../components/crumb/index'
    import {findOrderInfo,findOrderInfoForShop,allPushContent,userCheckOver,delForUser,sendOrder,returnOrder,returnOrderNo,statusOnline} from '../../api/order'
  export default {
        data(){
            return {
                userInfo:JSON.parse(localStorage.getItem('user'))||null,
                photoImg:require('../../assets/images/mrtx.png'),
                addressInfo:null,
                goodsInfo:null,
                shopInfo:null,
                orderInfo:null,
                isCanPay:true,
                nowTime:'',
                timeDiff:0,
                timeDown:'00:00:00',
                countDownInterval:null
            }
        },
      components:{
          navCrumb
      },
      computed:{
            orderId(){
                return this.$route.params.id||'';
            },
          role(){
                return this.$route.params.role||'user';
          }
      },
      created () {
            this.findOrderInfoData();
      },
      methods:{
          applyStatus(status,orderInfo){
              //isOnline 3拒绝申请 2 同意申请
              let str = status==2?'是否线下收到支付款项，同意线下订单支付申请？':'是否拒绝线下订单支付申请？';
              this.$confirm('', str, {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
              }).then(() => {
                  statusOnline({
                      orderId:orderInfo.id,
                      status
                  }).then(res=>{
                      this.findOrderInfoData();
                  })
              }).catch(() => {});

          },
            getTimeDiff(){
                let end = Date.parse(this.orderInfo.createTime)+24*60*60*1000;
                let currTimeStamp=Date.parse(this.nowTime);
                this.timeDiff = end - currTimeStamp;
                if(this.timeDiff>0){
                    this.timeCount();
                }
            },
          timeCount() {
              let  hrText = '00',minText = '00',secText = '00';
              if (this.timeDiff >= 0) {
                  let hr = parseInt(this.timeDiff / 1000 / 60 / 60 % 24);
                  let min = parseInt(this.timeDiff / 1000 / 60 % 60);
                  let sec = parseInt(this.timeDiff / 1000 % 60);
                  hrText = hr > 9 ? hr : '0' + hr;
                  minText = min > 9 ? min : '0' + min;
                  secText = sec > 9 ? sec : '0' + sec;
              }else {
                  hrText = '00';
                  minText = '00';
                  secText = '00';
              }
              this.timeDown =  hrText+':'+minText+':'+secText;
              const that = this;
              that.countDownInterval=setTimeout(function () {
                  that.timeDiff-=1000;
                  if (that.timeDiff < 0) {
                      clearTimeout(that.countDownInterval);
                  }else {
                      that.timeCount()
                  }
              }, 1000);
          },
          orderPayText(createTime,status,goodsType,isReturn){
              let statusStr;
              let createTimeStamp=parseInt(Date.parse(createTime));
              let nowTimeStamp = parseInt(this.currTimeStamp);
              let failureTime = createTimeStamp+(24*60*60*1000);//超过24小时后订单失效
              switch (status){
                  case 0:
                          if(this.goodsInfo.goodsType==1){
                              statusStr=this.role==='user'?'待付款':'等待买家付款';

                          }else {
                              if(this.timeDiff>0){
                                  statusStr=this.role==='user'?'待付款':'等待买家付款';
                              }else {
                                  statusStr='已失效'
                              }
                          }
                      break;
                  case 1:
                      statusStr ='待发货';
                      break;
                  case 2:
                      statusStr =this.role==='user'?'待收货':'等待买家收货';
                      break;
                  case 3:
                      statusStr ='待评价';
                      break;
                  case 4:
                      statusStr ='已完成';
                      break;
                  case 5:
                      statusStr = isReturn==0?(this.role==='user'?'售后审核中':'售后'):isReturn==1?'已退款':isReturn==2?'已拒绝':'';
                      break;
                  case 6:
                      statusStr = '已失效';
                      break;
                  default:
                      statusStr ='';
                      break;
              }
              return statusStr;
          },
          findOrderInfoData(){
              if(this.orderId!==''){
                  if(this.role==='user'){
                      findOrderInfo({
                          orderId:this.orderId,
                          userId:this.userInfo.userId
                      }).then(res=>{
                          this.addressInfo=res.data.address;
                          this.goodsInfo=res.data.goods;
                          this.orderInfo=res.data.order;
                          this.shopInfo=res.data.shop;
                          this.nowTime=res.nowTime;
                          this.getTimeDiff();
                      })
                  }else {
                      findOrderInfoForShop({
                          orderId:this.orderId,
                          shopId:this.userInfo.shopId
                      }).then(res=>{
                          this.addressInfo=res.data.address;
                          this.goodsInfo=res.data.goods;
                          this.orderInfo=res.data.order;
                          this.nowTime=res.nowTime;
                          this.getTimeDiff();
                      })
                  }

              }

          },
          cancelOrder(orderId,shopId){
              this.$confirm('确认取消订单？')
                  .then(()=> {
                      delForUser({
                          shopId,
                          orderId
                      }).then((res)=>{
                          this.$message({
                              message:res.msg,
                              type:'success'
                          });
                          this.findOrderInfoData()
                      }).catch(err=>err);
                  }).catch(() => {});
          },
          delOrder(orderId,shopId){
              this.$confirm('确认删除订单？')
                  .then(()=> {
                      delForUser({
                          shopId,
                          orderId
                      }).then((res)=>{
                          this.$message({
                              message:res.msg,
                              type:'success'
                          });
                          this.findOrderInfoData()
                      }).catch(err=>err);
                  }).catch(() => {});
          },
          allPushContentOpt(orderId){
              allPushContent({
                  userId:this.userInfo.userId,
                  orderId
              }).then(res=>{
                  this.$message({
                      message:res.msg,
                      type:'success'
                  });
                  this.findOrderInfoData()
              }).catch(err=>err);
          },
          orderCheckOver(orderId){
              this.$confirm('确认收货？')
                  .then(()=> {
                      userCheckOver({
                          userId:this.userInfo.userId,
                          orderId
                      }).then(()=>{
                          this.$message({
                              message:'确认收获成功',
                              type:'success'
                          });
                          this.findOrderInfoData()
                      }).catch(err=>err);
                  }).catch(() => {});

          },
          sendOrder(orderId,distributionFee){
              if(distributionFee==-1){
                  sendOrder({
                      orderId
                  }).then(res=>{
                      this.$message({
                          type: 'success',
                          message: res.msg
                      });
                      this.findOrderInfoData()
                  })
              }else{
                  this.$prompt('填写运单号', '', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      inputValidator:(val)=>{
                          if(!val){
                              return false;
                          }
                      },
                      inputErrorMessage: '运单号不能为空'
                  }).then(({ value }) => {
                      sendOrder({
                          takeNum:value,
                          orderId
                      }).then(res=>{
                          this.$message({
                              type: 'success',
                              message: res.msg
                          });
                          this.findOrderInfoData()
                      })
                  }).catch(() => {});
              }
          },
          setReturnOrder(orderId){
              this.$prompt('退款', '', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputPlaceholder:'请输入退款金额',
                  inputValidator:(val)=>{
                      if(!val){
                          return false;
                      }
                  },
                  inputErrorMessage: '退款金额不能为空'
              }).then(({ value }) => {
                  returnOrder({
                      shopId:this.userInfo.shopId,
                      money:value,
                      orderId
                  }).then(res=>{
                      this.$message({
                          type: 'success',
                          message: res.msg
                      });
                      this.findOrderInfoData()
                  })
              }).catch(() => {});
          },
          setReturnOrderNo(orderId){
              this.$confirm('确认拒绝退款？')
                  .then(()=> {
                      returnOrderNo({
                          orderId
                      }).then((res)=>{
                          this.$message({
                              message:res.msg,
                              type:'success'
                          });
                          this.findOrderInfoData()
                      }).catch(err=>err);
                  }).catch(() => {});
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .order-detail{
    .crumb-pt{
      padding:20px 0;
    }

    .order-status{
      display: table;
      width:100%;
      background-color:#fff;
      text-align: center;
      li{
        .status-flag{font-size:18px;
          font-weight:500;color:#222222;}
        .btn-buyOnce{width:84px;height:27px;margin-top:20px;color:#333;}
        &:first-child{width:256px;}
        display: table-cell;
        vertical-align: middle;
        border:1px solid #DBDBDB;
        padding:40px 80px;
      }
    }
    .steps-main{
      width:800px;
      height:100px;
      position: relative;
      font-size:22px;
      font-weight:500;
      .line{
        width:646px;
        height:5px;
        background-color:#EEEEEE;
        position: absolute;
        top:43px;
        left:52px;
      }
      .line-active{width:184px;height:5px;position: absolute;top:43px;
        background-color:$main-color;
        z-index: 110;}
      .line0-active{left:84px;}
      .line1-active{left:300px;}
      .line2-active{left:516px;}
      .step-name{
        position: absolute;
        top:10px;
        color:#222222;
        font-size:13px;
        &.step1-name{left:42px;}
        &.step2-name{left:260px;}
        &.step3-name{left:470px;}
        &.step4-name{left:690px;}
      }
      .step-time{
        position: absolute;
        color:#999999;
        font-size:13px;
        top:70px;
        &.step1-time{left:0px;}
        &.step2-time{left:212px;}
        &.step3-time{left:430px;}
        &.step4-time{left:650px;}
      }
      .step{
        position: absolute;
        top:30px;
        width:32px;
        height:32px;
        text-align: center;
        line-height:32px;
        background-color:#EEEEEE;
        color:#CCCCCC;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        z-index: 100;
        &.active{
          color:#fff;
          background-color:$main-color;
        }
        &.step1{
          left:52px;
        }
        &.step2{
          left:268px;
        }
        &.step3{
          left:484px;
        }
        &.step4{
          left:700px;
        }
      }

    }
    .order-info{
      overflow: hidden;
      padding:0px 50px;
      background-color:#fff;
      .name{
        font-size:14px;
        color:#222222;
        font-weight:600;
        padding:30px 0 20px;
      }
      .order-item{
        overflow: hidden;
        font-size:12px;
        li{
          width:50%;
          float: left;
          color:#999999;
          line-height:24px;
          span{
            color:#222;
          }
        }
      }
      .tab-list{
        font-size:16px;
        clear: both;
        .goods-img{
          width:100px;
          height:100px;
          float: left;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          border-radius: 5px;}
        .goods-name{
          float: left;
          vertical-align: top;
          padding-left:10px;
          line-height: 24px;
          width:207px;
        }
        .btn-item{
          display: block;
          background-color:#F5F5F5;
          &+.btn-item{margin-top:10px;}
        }
      }
      .count-list{
        padding:20px 0 50px;
        width:212px;
        font-size:12px;
        float: right;
        p{
          height:32px;
          line-height:32px;
          &>span:first-child{
            float: left;color:#222;}
          &>span:last-child{
            float: right;color:#333;}
          .total-money{font-size:18px;color:#FF2D2D}
        }
      }
    }
    .tab-head{
      display: table;
      width:100%;
      height:40px;
      background-color:#F5F5F5;
      font-size:14px;
      color:#333;
      li{
        display: table-cell;
        vertical-align: middle;
        text-align: left;
        width:124px;
        &:first-child{
          width:400px;
          padding-left:20px;
        }

      }
    }
    .tab-body{
      display: table;
      width:100%;
      border-bottom:1px solid #E0E0E0;
      li{
        display: table-cell;
        vertical-align: top;
        text-align: left;
        width:124px;
        padding:20px 0;
        .btn-item{background-color:#F5F5F5;border-color:#D9D9D9;}
        .btn-item+.btn-item{
          display: block;
          margin-top:10px;
        }
        &:first-child{
          width:400px;
          text-align: left;
          padding-left:20px;
        }
      }
      .order-img{
        display: inline-block;
        width:100px;
        height:100px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background-color:$main-color;
      }
      .order-title{
        display: inline-block;
        font-size:16px;
        padding-left:10px;
        width:208px;
        vertical-align: top;
        padding-top:8px;
      }
    }
  }
</style>
<style lang="scss">
  @import '../../assets/css/common';
</style>
